import { inject, Injectable, signal } from '@angular/core';
import { Match } from '../_shared/models/match.model';
import { BoardHelpService } from '../match-tracker/tracker-board/board-help.service';
import { MatchUpStatusEnum } from '../_shared/models/csTypes/enums/matchup_status';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OfficialViewService {
  private bhs = inject(BoardHelpService);
  private swapSidesSubject = new Subject<void>();
  // Observable to notify when swapSides() should be called
  swapSides$ = this.swapSidesSubject.asObservable();

  areSidesReversed!: boolean;

  constructor() { }

  swapSides(match: Match) {

    if (match.matchStatus !== 'TBP') {
        this.areSidesReversed = !!!this.bhs.getLastPoint(match)?.extensions?.find(ext => ext.name === 'areSidesReversed')?.value;

        this.bhs.getLastPoint(match)!.extensions!.find(ext => ext.name === 'areSidesReversed')!.value = this.areSidesReversed;

    }
  }

  isCompleted(match: Match): boolean {
    return match.matchStatus === MatchUpStatusEnum.COMPLETED;
  }

  isInterrupted(match: Match): boolean {
    return match.matchStatus === MatchUpStatusEnum.RETIRED ||
      match.matchStatus === MatchUpStatusEnum.DEFAULTED ||
      match.matchStatus === MatchUpStatusEnum.INCOMPLETE ||
      match.matchStatus === MatchUpStatusEnum.ABANDONED ||
      match.matchStatus === MatchUpStatusEnum.SUSPENDED;
  }

  // Method to trigger the swapSides event
    triggerSwapSides() {
        this.swapSidesSubject.next();
    }

}
